import InstitutionSelectionModal from "features/libraries/components/InstitutionSelectionModal";
import { useInstitutionSelectionModal } from "features/libraries/hooks/useInstitutionSelectionModal";

/**
 * Wrapper component that manages the institution selection modal state
 * This component uses the hook to determine when to show the modal
 */
const InstitutionSelectionModalWrapper: React.FC = () => {
  const { showModal, handleConfirm, handleCancel, matchingLibraries } =
    useInstitutionSelectionModal();

  return (
    <InstitutionSelectionModal
      open={showModal}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      matchingLibraries={matchingLibraries}
    />
  );
};

export default InstitutionSelectionModalWrapper;
